<template>
    <div v-show="isLoading()" class="yamaha-ui-loader absolute inset-0 w-full">
        <div class="absolute inset-0 w-full h-12 m-auto">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "./mixins/Loader";

export default {
    name: "UiLoader",
    mixins: [Loader],
    created() {
        if (window.EventBus) {
            window.EventBus.$on("toggle-loader", loading => {
                this.toggleLoader(loading);
            });
        }
    }
};
</script>

<style scoped>
.yamaha-ui-loader {
    z-index: 99999;
}
</style>
